module.exports = __webpack_public_path__ + "static/img/planta-icmBio.4fcfb66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planta-icmBio.png
// module id = zmnG
// module chunks = 11